import { Navigate, useSearchParams } from 'react-router-dom';
import RenewalFeedbackSurvey from '@/components/FeedbackSurvey/RenewalFeedbackSurvey';
import FeedbackSurveyPlaceholder from '@/components/FeedbackSurvey/FeedbackSurveyPlaceholder';
import { parseFeedbackSurveyType } from '@/components/FeedbackSurvey/feedbackSurveyTypes';

const FeedbackSurveyPage = () => {
  const [searchParams] = useSearchParams();
  const type = parseFeedbackSurveyType(searchParams.get('type'));

  if (!type) {
    return <Navigate to="/feedback-survey?type=feedback" replace />;
  }

  switch (type) {
    case 'renewal':
      return <RenewalFeedbackSurvey />;
    case 'feedback':
    default:
      return <FeedbackSurveyPlaceholder />;
  }
};

export default FeedbackSurveyPage;
